import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventsIndexComponent } from './crud-index/crud-index.component';
import { EventsCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: EventsIndexComponent,
  },
  {
    path: 'create',
    component: EventsCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: EventsCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: EventsCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventsRoutingModule { }
